import {
  PorkteinRoot,
  Feat1,
  Feat2,
  Feat3,
  BagImage,
  BlobWrapper,
  Shoelace,
  Cup,
  Snake,
  BadgeWrapper,
  ButtonWrapper,
  BorderWrapper,
  UnboxingWrapper,
} from './Porktein.styles'
import Image from 'next/image'
import bag from '../../../../../../../../public/assets/product/porkteinBag.png'
import blob from '../../../../../../../../public/assets/product/treatsBlob.svg'
import shoelace from '../../../../../../../../public/assets/product/shoeLaceArrow.png'
import cup from '../../../../../../../../public/assets/product/cupArrow.png'
import snake from '../../../../../../../../public/assets/product/snakeArrow.png'
import badge from '../../../../../../../../public/assets/badge-3-red.svg'
import { useTranslation } from 'hooks/useTranslation'
import { SectionTitle } from 'features/ECommerce/screens/AllProducts/AllProducts.styles'
import { Button } from 'components/Button'
import { ColorTokens, theme } from 'stitches.config'
import { BorderWave } from 'components/BorderWave'
import Unboxing from '../../../../../../../../public/assets/product/Unboxing.png'

interface TreatsBlobProps {
  color: ColorTokens
}

export const TreatsBlob = ({ color }: TreatsBlobProps) => {
  const colorValue = theme.colors[color].value
  return (
    <svg
      width="921"
      height="435"
      viewBox="0 0 921 435"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M888.59 283.132C925.03 228.472 938.08 138.822 884.62 89.9425C831.16 41.0625 537.82 -56.0875 430.47 71.3925C283.84 245.512 246.08 23.4425 178.33 4.30249C35.5502 -36.0275 -64.8198 218.462 49.7302 296.362C164.29 374.262 189.14 468.522 297.58 422.702C406.03 376.882 480.87 303.562 566.4 309.672C651.93 315.782 861.08 324.382 888.58 283.142L888.59 283.132Z"
        fill={colorValue}
      />
    </svg>
  )
}

export const Porktein = () => {
  const { t } = useTranslation()
  return (
    <>
      <PorkteinRoot>
        <SectionTitle className="d-only">{t('products:treats.porktein.title')}</SectionTitle>
        <SectionTitle css={{ maxWidth: '300px' }} className="m-only">
          {t('products:treats.porktein.title-mobile')}
        </SectionTitle>
        <BagImage>
          <Image src={bag} alt={t('products:treats.porktein.imageAlt')} />
        </BagImage>
        <BlobWrapper>
          <TreatsBlob color="tertiary-200" />
        </BlobWrapper>
        <BadgeWrapper>
          <Image
            src={badge}
            objectFit="cover"
            layout="fill"
            alt={t('recipes:overview.hero.badge')}
          />
        </BadgeWrapper>
        <Feat1
          align="center"
          weight="semiBold"
          size={{ '@initial': 'headline', '@bp3': 'bodyExtraLarge' }}
          color="accent-black"
        >
          {t('products:treats.porktein.feat-1')}
        </Feat1>
        <Feat2
          align="center"
          weight="semiBold"
          size={{ '@initial': 'headline', '@bp3': 'bodyExtraLarge' }}
          color="accent-black"
        >
          {t('products:treats.porktein.feat-2')}
        </Feat2>
        <Feat3
          align="center"
          weight="semiBold"
          size={{ '@initial': 'headline', '@bp3': 'bodyExtraLarge' }}
          color="accent-black"
        >
          {t('products:treats.porktein.feat-3')}
        </Feat3>
        <Shoelace>
          <Image src={shoelace} alt="" />
        </Shoelace>
        <Cup>
          <Image src={cup} alt="" />
        </Cup>
        <Snake className="d-only">
          <Image src={snake} alt="" />
        </Snake>
        <ButtonWrapper>
          <Button>{t('products:treats.hero.cta')}</Button>
        </ButtonWrapper>
      </PorkteinRoot>
      <BorderWrapper>
        <UnboxingWrapper>
          <Image src={Unboxing} alt="" />
        </UnboxingWrapper>
        <BorderWave
          background="tertiary-200"
          svgHeight="78px"
          invert
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
      </BorderWrapper>
    </>
  )
}
